export default __webpack_public_path__ + "static/media/IconDesc_SpelevatorPart_1.256.43da74f2.png";